import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Alert,
} from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import * as React from 'react';
import { GradientFab } from '../../atoms';

export interface RatingDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (textInput: string) => void;
  rating?: React.ReactElement;
  error: boolean;
}

const RatingDialog = ({ open, onClose, rating, onSubmit, error }: RatingDialogProps) => {
  const [textInput, setTextInput] = useState('');
  const [disabled, setDisabled] = useState(false);
  const { t } = useTranslation();
  const handleSubmit = () => {
    setDisabled(true);
    onSubmit(textInput);
    setTimeout(() => setDisabled(false), 3000);
  };
  return (
    <Dialog open={open}>
      <DialogTitle>{t('file.rating.dialog.title')}</DialogTitle>
      <DialogContent dividers>
        {t('file.rating.dialog.description')}
        {rating}
        <TextField
          label={t('file.rating.dialog.input')}
          multiline
          type="text"
          fullWidth
          margin={!rating ? 'normal' : 'none'}
          minRows={2}
          variant="outlined"
          helperText={t('file.rating.dialog.optional_flag')}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setTextInput(event.target.value);
          }}
        />
        {error && <Alert severity="error">{t('common.error')}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          {t('common.cancel')}
        </Button>
        <GradientFab
          size="small"
          gradient="primary"
          disabled={disabled}
          onClick={handleSubmit}
          type="submit"
        >
          {t('common.confirm')}
        </GradientFab>
      </DialogActions>
    </Dialog>
  );
};

export default RatingDialog;
